import { useContext } from "react";
import { Box } from "@mui/material";

import { CustomerSelectorContainer } from "./customer_selector/container";
import { ProfileMenu } from "./profile_menu";
import { StartRunButtonContainer } from "./start_run_button/container";
import { LockForecastButtonContainer } from "./lock_forecast_button/container";
import { TOP_HEADER_HEIGHT } from "./const";
import { useAdmin } from "../../contexts/app/provider";
import { VersionedDataContext } from "../../contexts/versioned_data/context";
import { RunSelectorContainer } from "./run_selector/container";

export const TopHeader = () => {
  const { isAdmin, loading: isAppContextLoading } = useAdmin();
  const { loading: isVersionedDataLoading } = useContext(VersionedDataContext);

  const loading = isAppContextLoading || isVersionedDataLoading;

  return (
    <Box
      sx={{
        p: 2,
        pl: 0,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: `${TOP_HEADER_HEIGHT}px`,
      }}
    >
      <Box>{isAdmin && !loading && <CustomerSelectorContainer />}</Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <RunSelectorContainer />
        {isAdmin && <LockForecastButtonContainer />}

        <Box
          sx={{
            display: `flex`,
            alignItems: `center`,
            justifyContent: `space-between`,
            mt: 1,
          }}
        >
          <StartRunButtonContainer />
          <ProfileMenu />
        </Box>
      </Box>
    </Box>
  );
};
